import { struct } from 'io-ts/Decoder';

import { PackageName } from '../../../../../whole-house/canvas/PackageName';
import { Id as TakeOffId } from '../../../../../whole-house/take-off/Id';

export const Request = struct({
	takeOffId: TakeOffId,
	packageName: PackageName,
});
